// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"ce45f9fc","171":"ea6f8820","378":"b83f523d","453":"52b8d009"}[chunkId] + ".chunk.js";
};